export enum BuyApprovalStatusEnum {
  Pending = "Pending",
  Approved = "Approved",
  Rejected = "Rejected",
}
